import { render, staticRenderFns } from "./v80b1030 copy.vue?vue&type=template&id=601468b4&scoped=true&"
import script from "./v80b1030 copy.vue?vue&type=script&lang=js&"
export * from "./v80b1030 copy.vue?vue&type=script&lang=js&"
import style0 from "./v80b1030 copy.vue?vue&type=style&index=0&id=601468b4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601468b4",
  null
  
)

export default component.exports